import { createFetchedDataRecord } from '../../../../utils/fetched-data/create-fetched-data-record';
import { updateObject } from '../../../../utils/object-utils';
import { salesDataDomainStore } from '../../store';
import { assignItemRelatedData } from './assign-item-related-data';
export const assignItemProfileRelatedData = (relatedData, cacheDuration) => {
    assignItemRelatedData(relatedData, cacheDuration);
    updateObject(salesDataDomainStore.data.itemsById, createFetchedDataRecord(relatedData.items, 'id', cacheDuration));
};
